import baseApi from './base'

const login = params => 
  baseApi.request({
    method: 'post',
    url: '/login',
    params
  })

const logout = () =>
  baseApi.request({
    method: 'post',
    url: '/logout'
  })

const validate = () =>
  baseApi.request({
    method: 'get',
    url: '/home/validate'
  })

const changeIdentity = data =>
  baseApi.request({
    method: 'put',
    url: '/user/change-identity',
    data
  })

const fetchAll = params =>
  baseApi.request({
    method: 'get',
    url: '/users',
    params
  })

const fetchOne = id => 
  baseApi.request({
    method: 'get',
    url: `/users/${id}`
  })

const modifyOne = (id, data) =>
  baseApi.request({
    method: 'patch',
    url: `/users/${id}`,
    data
  })

const createOne = (id, data) =>
  baseApi.request({
    method: 'post',
    url: '/users',
    data
  })

const deleteAll = data =>
  baseApi.request({
    method: 'delete',
    url: '/users',
    data
  })

const modifyPassword = (id, data) =>
  baseApi.request({
    method: 'patch',
    url: `/users/${id}/password`,
    params: data
  })

const resetPassword = (id, data) =>
  baseApi.request({
    method: 'patch',
    url: `/users/${id}/reset-password`,
    params: data
  })

const ftrUsers = params =>
  baseApi.request({
    method: 'get',
    url: '/users/ftr',
    params
  })

const downloadUserTemplate = () =>
  baseApi.request({
    method: 'get',
    url: '/users/download-template',
    responseType: 'blob'
  });

const uploadUsers = data =>
  baseApi.request({
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    method: 'post',
    url: '/users/upload',
    responseType: 'blob',
    data
  });

const fetchAllUsers = params =>
  baseApi.request({
    method: 'get',
    url: '/users/all',
    params
  });

const modifyProfile = data =>
  baseApi.request({
    method: 'patch',
    url: '/users/info',
    data
  });

const register = data =>
  baseApi.request({
    method: 'post',
    url: '/register',
    data
  });

const retrievePassword = data =>
  baseApi.request({
    method: 'post',
    url: '/retrieve-password',
    data
  });

const checkPasswordTime = data =>
  baseApi.request({
    method: 'post',
    url: '/user/check-password-time',
    data
  });

const getPhoneCaptcha = data =>
  baseApi.request({
    method: 'post',
    url: '/get-phone-captcha',
    data
  });

export {
  login,
  logout,
  validate,
  changeIdentity,
  fetchAll,
  fetchOne,
  modifyOne,
  createOne,
  deleteAll,
  modifyPassword,
  resetPassword,
  ftrUsers,
  downloadUserTemplate,
  uploadUsers,
  fetchAllUsers,
  modifyProfile,
  register,
  retrievePassword,
  checkPasswordTime,
  getPhoneCaptcha
};


// WEBPACK FOOTER //
// ./src/api/user.js